var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66927 7.99991C1.66927 11.3132 4.70927 13.9332 8.14927 13.2132C10.3026 12.7599 11.9759 10.9466 12.2826 8.76658C12.4293 7.70658 12.2759 6.67324 11.8159 5.71324C11.7293 5.53324 11.6893 5.33991 11.6893 5.13991C11.6893 5.01324 11.7093 4.88658 11.7426 4.76658L12.1959 3.22658C12.2693 2.97324 12.0359 2.73324 11.7759 2.80658L10.1826 3.27324C9.8826 3.35991 9.56927 3.31991 9.2826 3.17991C8.5626 2.83991 7.78927 2.66658 7.0026 2.66658C4.0626 2.66658 1.66927 5.05991 1.66927 7.99991ZM0.335937 7.99991C0.335937 4.31991 3.3226 1.33324 7.0026 1.33324C8.02927 1.33324 8.98927 1.57324 9.8626 1.97991L13.1693 1.00658C13.6693 0.85991 14.1426 1.33324 13.9893 1.83991L13.0159 5.14658C13.5426 6.25324 13.7826 7.51991 13.6093 8.86658C13.2159 11.9066 10.7093 14.3399 7.6626 14.6399C3.68927 15.0199 0.335937 11.8999 0.335937 7.99991Z",
    fill: "#3C228A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.e97cf6bab5c90277f57fa0e76bea596e.svg";
export { ForwardRef as ReactComponent };